// removed by extract-text-webpack-plugin
module.exports = {"action":"styles-module__action___xO7pF","actionText":"styles-module__actionText___7o3gA"};


//////////////////
// WEBPACK FOOTER
// ./src/core/components/Action/styles.module.css
// module id = 413
// module chunks = 0